import React, {FC} from 'react';
import {connect} from "react-redux";
import WrapperPreloader from "../../components/WrapperPreloader";
import MixPage from "../../components/Main/MixPage";
import {updateMixerMix} from "../../modules/TastesBrand";
import {IMix} from "../../constants/types";

interface IMixerMixPage {
    mixes: Array<IMix>,
    isLoading: boolean,
    selectedMix: number,
    updateMixerMix: any
}

const MixerMixPage: FC<IMixerMixPage> = ({
                                             mixes,
                                             isLoading,
                                             selectedMix,
                                             updateMixerMix
                                         }) => {
    return (
        <WrapperPreloader
            isLoading={isLoading}
        >
            <MixPage
                mix={mixes[selectedMix]}
                handleLikeButton={updateMixerMix}
            />
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.tastesBrand.isLoading,
    mixes: state.tastesBrand.resultMixer,
    selectedMix: state.tastesBrand.selectedMix,
});

const mapDispatchToProps = (dispatch: any) => ({
    updateMixerMix: (id: number, isMixLiked: boolean) => dispatch(updateMixerMix(id, isMixLiked)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MixerMixPage)

